import type { AppProps } from 'next/app';
import { I18nProvider } from 'next-localization';

import Bootstrap from 'src/Bootstrap';

import { GoogleRecaptchaManagerProvider } from '../contexts/GoogleRecaptchaManagerContext';
import { FormPageProps } from '../types/formPageProps';
import ErrorPage from './_error';

import 'assets/app.css';
import './../../styles/globals.css';
import 'assets/app.css';

function App({ Component, pageProps }: AppProps<FormPageProps>): JSX.Element {
  const { dictionary, envConfig, ...rest } = pageProps;

  if (!envConfig) {
    console.error('No environment configuration found');
    return <ErrorPage />;
  }

  return (
    <>
      <Bootstrap {...pageProps} />
      {/*
        // Use the next-localization (w/ rosetta) library to provide our translation dictionary to the app.
        // Note Next.js does not (currently) provide anything for translation, only i18n routing.
        // If your app is not multilingual, next-localization and references to it can be removed.
      */}
      <I18nProvider lngDict={dictionary} locale={pageProps.locale}>
        <GoogleRecaptchaManagerProvider
          googleRecaptchaV3SiteKey={envConfig.googleRecaptchaV3SiteKey}
        >
          <Component {...rest} />
        </GoogleRecaptchaManagerProvider>
      </I18nProvider>
    </>
  );
}

export default App;
